import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import ReactSelect from '../../../../../common/components/UI/Select/ReactSelect';
import CustomButton from '../../../../../common/components/UI/Button/Button';
import DebouncedTextField from '../../../../components/DebouncedDurationField/DebouncedDurationField'
import { translate } from 'react-i18next';
import { camelCase } from 'lodash';
import { BreakRuleTriggerType, BreakRuleActionType } from '../../../../Enums/BreakRule';
import './BreakCalculation.scss';


function BreakCalculation({ breakRules, handleChangeSetting, ...props }) {

    const {t: translate} = props;
    const t = (prop) => translate(`workplanManager:settings.dataVisibility.${prop}`);

    const triggerTypeSelectOptions = Object.keys(BreakRuleTriggerType)
    .map(type => {return { 
        label: t(camelCase(type)), 
        value: BreakRuleTriggerType[type]
    }});

    const actionTypeSelectOptions = Object.keys(BreakRuleActionType)
    .map(action => {return { 
        label: t(camelCase(action)), 
        value: BreakRuleActionType[action]
    }});

    const handleAddBreakRule = () => {
        const lastId = Math.max(...breakRules.map(rule => rule.id));
        const emptyBreakRule = {
            triggerType: 0,
            triggerValue: 0,
            actionType: 0,
            actionValue: 0,
            id: lastId < 0 ? 0 : lastId + 1,
        }
        const newBreakRules = [...breakRules, emptyBreakRule];

        handleChangeSetting('breakRules', newBreakRules);
    }

    const handleChangeBreakRule = (target, input, breakRuleId) => {
        const newBreakRules = breakRules.map(rule =>
            rule.id === breakRuleId ? {...rule, [target]: input.value} : rule
        );

        handleChangeSetting('breakRules', newBreakRules);
    }

    const handleDeleteBreakRule = (breakRuleId) => {
        const newBreakRules = breakRules.filter(rule => rule.id !== breakRuleId);

        handleChangeSetting('breakRules', newBreakRules);
    }

    const handleChangeTriggerValue = (value, breakRuleId) => {
        handleChangeBreakRule(
            'triggerValue', 
            {value}, 
            breakRuleId
        );
    }

    const handleChangeActionValue = (value, breakRuleId) => {
        handleChangeBreakRule(
            'actionValue', 
            {value}, 
            breakRuleId
        );
    }
    
    const generateBreakRuleLine = (breakRule) => {
        return (
            <div className="bc-break-rule-Line">
                <div className="bc-break-rule-item-large">
                    <ReactSelect
                        value={triggerTypeSelectOptions.find(x => x.value === breakRule.triggerType)}
                        options={triggerTypeSelectOptions}
                        onChange={handleChangeBreakRule}
                        selectClass="bc-break-rule-select"
                        target={'triggerType'}
                        extraOnChange={breakRule.id}
                    />
                </div>
                <div className="bc-break-rule-item-medium">
                    <DebouncedTextField
                        key={`trigger-value-${breakRule.id}`}
                        onChange={(value) => handleChangeTriggerValue(value, breakRule.id)}
                        value={breakRule.triggerValue}
                    />
                </div>
                <div className="bc-break-rule-item-large">
                    <ReactSelect
                        value={actionTypeSelectOptions.find(x => x.value === breakRule.actionType)}
                        options={actionTypeSelectOptions}
                        onChange={handleChangeBreakRule}
                        selectClass="bc-break-rule-select"
                        target={'actionType'}
                        extraOnChange={breakRule.id}
                    />
                </div>
                <div className="bc-break-rule-item-medium">
                <DebouncedTextField
                        onChange={(value) => handleChangeActionValue(value, breakRule.id)}
                        value={breakRule.actionValue}
                        key={`action-value-${breakRule.id}`}
                    />
                </div>
                <div className="bc-break-rule-item-small">
                    <Button
                        onClick={() => handleDeleteBreakRule(breakRule.id)}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="bc-container">
            <Typography className="bc-regular-label">
                {t("breakCalculation")}
            </Typography>
            <div className="bc-break-rules-container">
                <div className="bc-break-rule-Line">
                    <div className="bc-break-rule-item-large bc-small-label">
                        {t("condition")}
                    </div>
                    <div className="bc-break-rule-item-medium bc-small-label">
                        {t("shiftDuration")}
                    </div>
                    <div className="bc-break-rule-item-large bc-small-label">
                        {t("action")}
                    </div>
                    <div className="bc-break-rule-item-medium bc-small-label">
                        {t("duration")}
                    </div>
                </div>
                {breakRules.map(breakRule => generateBreakRuleLine(breakRule))}
            </div>
            <CustomButton
                size={'small'}
                color={'secondary'}
                onClick={handleAddBreakRule}
            >
                {t("addCondition")}
            </CustomButton>

        </div>
    );

}

export default translate('workplanManager')(BreakCalculation);